import RidersMaternityStep from "components/steps/RidersMaternityStep";

const Step6Pages = () => <RidersMaternityStep />;

export default Step6Pages;
